export default __webpack_public_path__ + "static/monitored-animated-9e7da67a59ddfda040f0a628289b04ae.gif";